import { render, staticRenderFns } from "./BP_page.vue?vue&type=template&id=f4eb721e&scoped=true"
import script from "./BP_page.vue?vue&type=script&lang=js"
export * from "./BP_page.vue?vue&type=script&lang=js"
import style0 from "./BP_page.vue?vue&type=style&index=0&id=f4eb721e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4eb721e",
  null
  
)

export default component.exports